import httpRequest from "../../ajax";
import axios from "axios";
import qs from "qs";
import {
  ERROR,
  GET_BANKS,
  CREATE_BANK_ACCOUNT,
  GET_ACCOUNT_BALANCE,
  GET_BANK_ACCOUNT,
  GET_MY_ACCOUNTS,
  RESET_MY_ACCOUNTS,
  GET_TRANSACTIONS,
  CARD_CREATE_SUCCESS,
  GET_CARDS,
  RESET_CARDS,
  DELETE_BANK_ACCOUNT,
  SET_DEFAULT_CARD,
  FUND_WALLET,
  WITHDRAW_FROM_WALLET,
  TRANSFER_FROM_AVAILABLE,
  PAY_FOR_RESUME_ANALYSIS,
} from "../actionTypes";

// ─── Interleaved-& decoder ────────────────────────────────────────────────────
// The resume analysis API returns strings with "&" inserted between every
// character, e.g. "microservices" → "&m&i&c&r&o&s&e&r&v&i&c&e&s"
// Fix: split on "&" — if every segment is 0-1 chars it's this pattern, rejoin.
const decodeInterleavedAnds = (str) => {
  if (!str || typeof str !== "string") return str ?? "";
  const segments = str.split("&");
  const isInterleaved =
    segments.length > 3 && segments.every((seg) => seg.length <= 1);
  if (isInterleaved) return segments.join("");
  // Also handle standard HTML entities
  try {
    const txt = document.createElement("textarea");
    txt.innerHTML = str;
    return txt.value;
  } catch (_) {
    return str
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'");
  }
};

const deepDecode = (value) => {
  if (typeof value === "string") return decodeInterleavedAnds(value);
  if (Array.isArray(value)) return value.map(deepDecode);
  if (value && typeof value === "object") {
    const out = {};
    for (const k of Object.keys(value)) out[k] = deepDecode(value[k]);
    return out;
  }
  return value;
};
// ─────────────────────────────────────────────────────────────────────────────

export const getBanksList = (dispatch) => {
  httpRequest("get", "/wallet/withrawal/banks")
    .then(({ data: { data } }) => {
      const action = { type: GET_BANKS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const resetCards = (dispatch) => {
  const action = { type: RESET_CARDS, payload: [] };
  dispatch(action);
  return action;
};

export const createBankAccount = (dispatch, accountDetails) => {
  httpRequest("post", "/wallet/account/create", accountDetails)
    .then(({ data: { data } }) => {
      const action = { type: CREATE_BANK_ACCOUNT, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const getBankAccount = (dispatch, accountDetails) => {
  return httpRequest("get", "/wallet/account/get", accountDetails)
    .then(({ data: { data } }) => {
      const action = { type: GET_BANK_ACCOUNT, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const getAccountBalance = (dispatch) => {
  httpRequest("get", "/wallet/balance")
    .then(({ data: { data } }) => {
      const action = { type: GET_ACCOUNT_BALANCE, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const getMyAccounts = (dispatch, page, limit) => {
  httpRequest("get", `/wallet/account/${page}/${limit}`)
    .then(({ data: { data } }) => {
      const action = { type: GET_MY_ACCOUNTS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const resetMyAccounts = (dispatch) => {
  const action = { type: RESET_MY_ACCOUNTS, payload: [] };
  dispatch(action);
  return action;
};

export const getTransactions = (dispatch, page, perPage = 10) => {
  return httpRequest("get", `/wallet/payment/${page}/${perPage}`)
    .then(({ data }) => {
      console.log("TRANSACTIONS API RESPONSE - full data:", data);
      const action = { type: GET_TRANSACTIONS, payload: data };
      dispatch(action);
      return data;
    })
    .catch(({ response }) => ({
      payload: response?.message,
      type: ERROR,
    }));
};

export const getPendingTransactions = () => {
  return httpRequest("get", `/wallet/payment/pending`)
    .then(({ data }) => {
      console.log("PENDING TRANSACTIONS API RESPONSE:", data);
      return data;
    })
    .catch(({ response }) => {
      console.error("Failed to fetch pending transactions:", response);
      return { data: [] };
    });
};

export const createCardToken = (dispatch, data) => {
  try {
    const url = "https://api.stripe.com/v1/tokens";
    axios.defaults.headers.common.Authorization = `Bearer ${process.env.REACT_APP_STRIPE_API_KEY}`;
    axios({
      method: "post",
      url: url,
      data: qs.stringify(data),
      headers: {
        "content-type": "application/x-www-form-urlencoded;charset=utf-8",
      },
    })
      .then(({ data }) => {
        const action = { type: "CARD_TOKEN_SUCCESS", payload: data };
        createCard(dispatch, data.id);
        dispatch(action);
        return data;
      })
      .catch(({ response }) => {
        dispatch({
          payload: response?.data?.error?.message,
          type: ERROR,
        });
      });
  } catch (err) {}
};

export const createCard = (dispatch, token) => {
  const tokenData = { stripeToken: token };
  httpRequest("post", "/wallet/card/create", tokenData)
    .then(({ data: { data } }) => {
      const action = { type: CARD_CREATE_SUCCESS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const getCards = (dispatch) => {
  httpRequest("get", `/wallet/card/1/10`)
    .then(({ data: { data } }) => {
      const action = { type: GET_CARDS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.message,
      type: ERROR,
    }));
};

export const deleteBankAccount = async (dispatch, id) => {
  return await httpRequest("post", `/wallet/account/${id}/delete`, {})
    .then(({ data: { data } }) => {
      const action = { type: DELETE_BANK_ACCOUNT, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const setDefaultCard = (dispatch, cardId) => {
  httpRequest("post", `/wallet/card/setDefault/${cardId}`)
    .then(({ data: { data } }) => {
      const action = { type: SET_DEFAULT_CARD, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const fundWallet = (dispatch, fundData) => {
  httpRequest("post", `/wallet/payment/fundWallet`, fundData)
    .then(({ data: { data } }) => {
      const action = { type: FUND_WALLET, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const fundWalletWithPaystack = (dispatch, fundData) => {
  httpRequest("post", `/wallet/payment/fundWalletWithPaystack`, fundData)
    .then(({ data: { data } }) => {
      const action = { type: FUND_WALLET, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const fundWalletWithGPAY = (dispatch, fundData) => {
  httpRequest("post", `/wallet/payment/fundWalletWithGPAY`, fundData)
    .then(({ data: { data } }) => {
      const action = { type: FUND_WALLET, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const addCardPaystack = (dispatch, reference) => {
  httpRequest(
    "post",
    `/wallet/payment/verifyTransaction/${reference.reference}`,
    reference
  )
    .then(({ data: { data } }) => {
      const action = { type: CARD_CREATE_SUCCESS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => {
      const action = { type: ERROR, payload: response?.data?.message };
      dispatch(action);
      return action;
    });
};

export const transferFromAvailable = async (dispatch, payload) => {
  return await httpRequest("post", `/wallet/available/transfer`, payload)
    .then(({ data: { data } }) => {
      const action = { type: TRANSFER_FROM_AVAILABLE, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const withdrawFromWallet = async (dispatch, payload) => {
  return await httpRequest("post", `/wallet/withdrawal/withdraw`, payload)
    .then(({ data: { data } }) => {
      const action = { type: WITHDRAW_FROM_WALLET, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};

export const checkResumeAnalysisPayment = async (sessionToken = null) => {
  const params = sessionToken ? { session_token: sessionToken } : {};
  return await httpRequest("post", `/wallet/payment/checkResumeAnalysisPayment`, params)
    .then(({ data }) => data)
    .catch(() => ({ has_paid: false }));
};

export const invalidateResumeAnalysisSession = async (sessionToken) => {
  if (!sessionToken) return { status: false };
  return await httpRequest("post", `/wallet/payment/invalidateResumeAnalysisSession`, { session_token: sessionToken })
    .then(({ data }) => data)
    .catch(() => ({ status: false }));
};

export const payForResumeAnalysis = async (dispatch, payload) => {
  return await httpRequest(
    "post",
    `/wallet/payment/payForResumeAnalysis`,
    payload
  )
    .then(({ data }) => {
      const action = { type: PAY_FOR_RESUME_ANALYSIS, payload: data };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
      status: false,
      current_balance: response?.data?.current_balance,
      required_amount: response?.data?.required_amount,
    }));
};

export const requestProfessionalResumeReview = async (payload) => {
  return await httpRequest(
    "post",
    `/wallet/payment/requestProfessionalResumeReview`,
    payload
  )
    .then(({ data }) => data)
    .catch(({ response }) => ({
      status: false,
      message: response?.data?.message || "Failed to send request",
    }));
};

// ─── Resume Analysis — fetch + clean in one place ────────────────────────────
// Call this wherever you trigger the resume analysis API call.
// It decodes the interleaved-& corruption before the data ever hits Redux/state.
export const fetchResumeAnalysis = async (dispatch, payload) => {
  return await httpRequest(
    "post",
    `/resume/analyze`, // ← update this to your actual endpoint
    payload
  )
    .then(({ data }) => {
      // Clean ALL strings in the response at the source
      const cleanData = deepDecode(data?.data ?? data);
      const action = { type: "RESUME_ANALYSIS_SUCCESS", payload: cleanData };
      dispatch(action);
      return action;
    })
    .catch(({ response }) => ({
      payload: response?.data?.message,
      type: ERROR,
    }));
};